export const DIVIDER = ' | ';

export const analyticsParams = {
    stream: 'Стрим - Мессенджеры и чат-боты',
    product: 'ВТБ онлайн. Чат',
} as const;

export const goalCollections = {
    CLICK_ON_BUTTON: `Клики по кнопке`,
    SHOW_POPUP: `Показ popup`,
    SHOW_WIDGET: `Показ виджета`,
    WATCH_SCREEN: `Просмотр экрана`,
    ERRORS: `Ошибки`,
    CHOOSING_VALUE: 'Выбор значения',
    DISCONNECTED: 'Разрыв соединения',

    CHAT: `Чат`,
    CHAT_STATUSES: `Статусы чата`,
    CHAT_ACTIONS: `Действия в чате`,
    CHAT_SCREEN: `Экран чата`,
    CHAT_SCREEN_WITH_PREDICTIVE_INPUT_TIPS: `Экран чата с подсказками предиктивного ввода`,
    CHAT_PAGE_MENU: `Страница чата. Меню чата`,
    CHAT_PAGE_SETTINGS: `Страница чата. Настройки чата`,
    CHAT_PAGE_GALLERY_CONTENT: `Страница чата. Галерея контента`,
    CHAT_PAGE_QUICK_ACTIONS_MENU: `Страница чата. Меню Быстрых Операций`,
    CHAT_PAGE_UNAUTHORIZED_ZONE: `Страница авторизиции. Вход в ВТБ онлайн`,

    SURVEY: `Опрос`,
    SURVEY_SHOW: `Показ опроса в чате`,
} as const;
